exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".intro-page[data-v-0c2c73de]{display:grid;grid-template-rows:auto auto;height:100%;width:100%;padding:10% 20%;position:relative;text-align:center;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-ms-flex-line-pack:space-evenly;align-content:space-evenly;background-size:50px 50px;background-image:linear-gradient(90deg,#80808010 1px,transparent 0),linear-gradient(180deg,#80808010 1px,transparent 0)}", ""]);

// exports
